import React, {
  useRef,
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  Ref,
  useMemo,
} from "react";
import classnames from "classnames";

import Button, { XhButtonProps } from "../Button";

import "./index.scss";

export type refMe = {
  reset: () => void;
  begin: () => void;
  beginning: boolean;
};

export type ButtonType = "default" | "secondary" | "primary" | "warn";

export type ButtonShape = "square" | "round" | "rectangle";

export type ButtonSize = "default" | "mini" | "full";

export interface CaptchaProps extends XhButtonProps {
  timeout?: number;
  className?: string;
  styleName?: string;
  text?: string;
  onClick: () => Promise<boolean>;
  ref: Ref<refMe>;
  timeingTemp?: string;
  ingText?: string;
  onEnd?: () => void;
}

export type CaptchaRef = refMe;

const CountdownButton = forwardRef<
  refMe,
  Omit<CaptchaProps, "businessId" | "onGetRealnameAuthInfo" | "onLaunchapp">
>((props, fromRef) => {
  const {
    timeout = 59,
    text = "获取验证码",
    onClick,
    className,
    ingText = "s重新获取",
    onEnd,
    shape = "square",
    ...rest
  } = props;
  const intervalRef = useRef<NodeJS.Timeout | null>();
  const [time, setTime] = useState(0);
  const [disabled, setDisabled] = useState(false);

  const reset = (): void => {
    intervalRef.current && clearInterval(intervalRef.current);
    setTime(0);
    setDisabled(false);
  };

  useImperativeHandle(
    fromRef,
    () => ({
      reset,
      begin: counter,
      beginning: disabled,
    }),
    [disabled]
  );

  useEffect(() => {
    intervalRef.current && clearInterval(intervalRef.current);
    return () => {
      intervalRef.current && clearInterval(intervalRef.current);
    };
  }, []);

  // 倒计时
  const buttonText = useMemo((): string | number => {
    if (time) {
      return `${time}${ingText}`;
    }
    return text;
  }, [time, text, ingText]);

  const counter = () => {
    const now = Date.now();
    let nowStamp = now;

    setDisabled(true);

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    setTime(timeout);

    intervalRef.current = setInterval(() => {
      nowStamp = Date.now();
      const overTimeStamp = now + timeout * 1000 + 100;
      const leftTime = Math.max(
        Math.floor((overTimeStamp - nowStamp) / 1000),
        0
      );

      if (leftTime === 0) {
        intervalRef.current && clearInterval(intervalRef.current);
        setDisabled(false);
        onEnd && onEnd();
      }

      setTime(leftTime);
    }, 1000);
  };

  const handleClick = (): any => {
    const promise = onClick();
    if (promise && promise.then) {
      promise.then(counter).catch(() => {
        console.log("callback reject....");
        setDisabled(false);
      });
    }
  };

  return (
    <Button
      {...props}
      className={classnames("xh-captcha", className)}
      disabled={disabled}
      onClick={handleClick}
      type="secondary"
      shape={shape}
      {...rest}
    >
      {buttonText}
    </Button>
  );
});
export default CountdownButton;
